import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Event } from '../../shared/models/event';
import { EventDialogComponent, EventDialogResult } from '../event-dialog/event-dialog.component';
import { AdminService } from '../services/admin.service';
import { AuthenticationService } from '../services/authentication.service';
import { EventService } from '../services/event.service';
import { OrganizationService } from '../services/organization.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.css']
})
export class EventsListComponent implements OnInit {
  events: Event[] = [];

  public isUser = false;
  public isOrg = false;
  public isAdmin = false;

  constructor(
    private dialog: MatDialog,
    private authService: AuthenticationService,
    private eventService: EventService,
    private adminService: AdminService,
    private orgService: OrganizationService,
    private userService: UserService) { }

  ngOnInit() {
    this.authService.setSignedIn(true);

    setTimeout(() => this.authService.CheckPrivileges(), 1000);
    setTimeout(() => this.isAdmin = this.adminService.getAdminStatus(), 2000);
    setTimeout(() => this.isUser = this.userService.getUserStatus(), 2000);
    setTimeout(() => this.isOrg = this.orgService.getOrgStatus(), 2000);

    setTimeout(() => console.log(this.isAdmin, this.isUser, this.isOrg), 3000);
  }

  ngAfterViewInit() {
    this.refreshEvents();
  }

  deleteEvent(title: string): void {
    this.eventService.deleteEvent(title);
    this.refreshEvents()
  }

  async editEvent(eventToEdit: Event): Promise<void> {
    const dialogRef = this.dialog.open(EventDialogComponent, {
      width: '300px',
      data: {
        event: {
          title: eventToEdit.title,
          image: eventToEdit.image,
          description: eventToEdit.description,
          date: eventToEdit.date

        },
      },
    });

    dialogRef
      .afterClosed()
      .subscribe(async (result: EventDialogResult | undefined) => {
        if (!result) {
          return;
        }
        this.eventService.updateEvent(eventToEdit)
        this.refreshEvents()
      })
  }

  joinEvent(event: Event): void {
    this.eventService.joinEvent(event)
  }

  async refreshEvents(org?: string, interests?: string[]) {
    this.events = await this.eventService.getEvents(org, interests);
  }
}
